import React, { useEffect } from 'react'
import { useVehicleModle } from '../vehicleModel'
import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export const Vehicle = () => {
  const { loadData, resetState } = useVehicleModle()

  useEffect(() => {
    loadData().then()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetState])

  return <>
    <PageHeader />
    <DataBox />
  </>
}